import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import SubjectReferralModal from './SubjectReferralModal';
import Pagination from '../../common/Pagination';
import Headers from '../../tutor/Header';
import NavigationBar from '../../tutor/Navigation';
import { PATH } from '../../../../utils/Constants';
import { Loader } from './../../common/Loader';
import { RESPONSE_CONSTANT } from '../../../../utils/ResponseConstant';
import {
    getCompletedReferralList,
    getCreatedReferralList,
    submitSubjectReferralNotes,
} from '../../../action/educator/AppointmentAction';
import { getSessionSubjectList } from '../../../action/Admin/LevelThreeAction';
import { showNotification } from '../../../action/NotificationAction';
import { paginationCount } from '../../../../utils/URL';
import { validateSearchInput } from '../../../../utils/Utility';

class ReferralEducator extends Component {
    constructor(props) {
        super(props);
        const { location } = this.props;
        const { tabName } = location.state || {};
        this.state = {
            isTabName: tabName ? tabName : 'create',
            visitType: tabName ? 4 : 2,
            cancelAppoimentIsOpen: false,
            cancelationReason: '',
            subjectId: '',
            subCategoryId: '',
            educatorId: '',
            studentId: '',
            dropdownSubcategoryList: [],
            dropdownSubjectList: [],
            educatorList: [],
            studentList: [],
            isSubjectLoading: false,
            isSubcategoryLoading: false,
            isEducatorLoading: false,
            createReferralList: [],
            isLoading: false,
            completedReferralList: [],
            mobileNav: false,
            searchValue: '',
            currentPage: 0,
            todosPerPage: paginationCount,
            referralNotes: '',
            btnLoading: false,
        };
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    //componentDidMount
    componentDidMount() {
        this.getCreatedReferralList(
            this.state.searchValue,
            this.state.visitType,
            this.state.currentPage,
            this.state.todosPerPage
        );
    }

    //getCreatedReferralList
    getCreatedReferralList(search, visitType, pageNumber, itemsPerPage) {
        this.isLoading();
        const values = {
            search,
            visitType,
            pageNumber: pageNumber + 1,
            itemsPerPage: itemsPerPage,
            isCreated: this.state.isTabName === 'create',
        };
        this.props.getCreatedReferralList(values, (result) => {
            this.isLoading();
            if (result) {
                this.setState({
                    createReferralList: result.response.data,
                    totalPages: result.response.totalPages,
                    currentPage: result.response.pageNumber,
                });
            }
        });
    }

    //getCompletedReferralList
    getCompletedReferralList(search, visitType, pageNumber, itemsPerPage) {
        this.isLoading();
        const values = {
            search,
            visitType,
            pageNumber: pageNumber + 1,
            itemsPerPage: itemsPerPage,
        };
        this.props.getCompletedReferralList(values, (result) => {
            this.isLoading();
            if (result) {
                this.setState({
                    completedReferralList: result.response.data,
                    totalPages: result.response.totalPages,
                    currentPage: result.response.pageNumber,
                });
            }
        });
    }

    //getSubjects
    getSubjects(search) {
        this.setState({ isSubjectLoading: true });
        const values = {
            search,
            pageNumber: 1,
            itemsPerPage: 99999,
        };
        this.props.getSessionSubjectList(values, (result) => {
            this.setState({ isSubjectLoading: false });
            if (result) {
                this.setState({
                    dropdownSubjectList: result.response.data,
                    totalPages: result.response.totalPages,
                    currentPage: result.response.pageNumber,
                });
            }
        });
    }

    //submitSubjectReferralNotes
    submitSubjectReferralNotes = (
        educatorId,
        studentId,
        studentUserId,
        subjectId,
        subcategoryId
    ) => {
        console.log(
            '=====ReferralEducator - Submitting Referral====',
            'educatorId:',
            educatorId,
            'studentId:',
            studentId,
            'studentUserId:',
            studentUserId,
            'subjectId:',
            subjectId,
            'subcategoryId:',
            subcategoryId
        );
        if (!subjectId) {
            this.props.showNotification(
                RESPONSE_CONSTANT.SUBJECT_MANDATORY,
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }
        if (!educatorId) {
            this.props.showNotification(
                RESPONSE_CONSTANT.EDUCATOR_MANDATORY,
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }
        // if (!studentId) {
        //     this.props.showNotification(
        //         RESPONSE_CONSTANT.STUDENT_MANDATORY,
        //         RESPONSE_CONSTANT.WARNING
        //     );
        //     return;
        // }
        const { referralNotes } = this.state;
        const values = {
            educatorId: educatorId,
            studentId: studentUserId,
            subjectId: subjectId,
            subcategoryId: subcategoryId || null,
            notes: referralNotes,
        };
        console.log('=====Final values object being sent to API=====', values);
        this.setState({ btnLoading: true });
        this.props.submitSubjectReferralNotes(values, (response) => {
            this.setState({ btnLoading: false });
            if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.setState(
                    {
                        cancelAppoimentIsOpen: false,
                        isModalOpen: false,
                    },
                    () => {
                        this.props.showNotification(response.message, RESPONSE_CONSTANT.SUCCESS);
                        this.resetStateValue();
                        this.setState({
                            visitType:
                                this.state.isTabName === 'create'
                                    ? 2
                                    : this.state.isTabName === 'referral'
                                      ? 4
                                      : 7,
                        });
                        this.getCreatedReferralList(
                            this.state.searchValue,
                            this.state.visitType,
                            this.state.currentPage,
                            this.state.todosPerPage
                        );
                    }
                );
            } else {
                if (response.message) {
                    this.props.showNotification(response.message, RESPONSE_CONSTANT.WARNING);
                    this.setState({
                        cancelAppoimentIsOpen: false,
                        isModalOpen: false,
                    });
                }
            }
        });
    };

    //handlePageChange
    handlePageChange(event) {
        if (this.state.isTabName !== 'completed') {
            this.getCreatedReferralList(
                this.state.searchValue,
                this.state.visitType,
                Number(event.selected),
                this.state.todosPerPage
            );
        } else {
            this.getCompletedReferralList(
                this.state.searchValue,
                this.state.visitType,
                Number(event.selected),
                this.state.todosPerPage
            );
        }
    }

    //handleSearchUser
    handleSearchUser = (event) => {
        const type =
            this.state.isTabName === 'create' ? 2 : this.state.isTabName === 'referral' ? 4 : 7;
        const searchValue = event.target.value;
        if (validateSearchInput(searchValue) || searchValue === '') {
            this.setState({ searchValue });
            clearTimeout(this.state.timeout);
            const timeout = setTimeout(() => {
                if (type === 7) {
                    this.getCompletedReferralList(searchValue, type, 0, this.state.todosPerPage);
                } else {
                    this.getCreatedReferralList(searchValue, type, 0, this.state.todosPerPage);
                }
            }, 1000);
            this.setState({ timeout });
        }
    };

    //tabChange
    tabChange = (type) => {
        this.setState({ isTabName: type, searchValue: '' }, () => {
            this.setState(
                {
                    visitType:
                        this.state.isTabName === 'create'
                            ? 2
                            : this.state.isTabName === 'referral'
                              ? 4
                              : 7,
                },
                () => {
                    if (type === 'completed') {
                        this.getCompletedReferralList(
                            this.state.searchValue,
                            this.state.visitType,
                            0,
                            this.state.todosPerPage
                        );
                    } else {
                        this.getCreatedReferralList(
                            this.state.searchValue,
                            this.state.visitType,
                            0,
                            this.state.todosPerPage
                        );
                    }
                }
            );
        });
    };

    //onClickMobileNav
    onClickMobileNav = (type) => {
        this.setState({ mobileNav: type });
    };

    //isLoading
    isLoading() {
        this.setState({ isLoading: !this.state.isLoading });
    }

    //openCancelModal
    openCancelModal = (visitId) => {
        this.setState({ cancelAppoimentIsOpen: true, visitId: visitId });
    };

    //resetStateValue
    resetStateValue = () => {
        this.setState({
            subjectId: '',
            subcategoryId: '',
            educatorId: '',
            studentId: '',
            referralNotes: '',
        });
    };

    render() {
        let pageDisplayCount = this.state.totalPages;
        return (
            <>
                <div className="fixed top-0 left-0 flex w-full h-full">
                    <div
                        className={`bg-black bg-opacity-50 fixed top-0 left-0 w-full h-full z-10 ${
                            this.state.mobileNav ? 'block' : 'hidden'
                        }`}
                    ></div>
                    <NavigationBar
                        nav={true}
                        {...this.props}
                        active={PATH.IM_PHYSICIAN.REFERRAL}
                        mobileNav={this.state.mobileNav}
                        onClickMobileNav={this.onClickMobileNav}
                    />
                    <main className="flex flex-col flex-grow overflow-hidden">
                        <Headers
                            {...this.props}
                            title="Referral"
                            onClickMobileNav={this.onClickMobileNav}
                        />
                        <div className="flex flex-col w-full h-full py-8 overflow-auto bg-UIBackground">
                            <div className="items-center justify-between px-4 sm:flex sm:px-8">
                                <h6 className="m-0 text-4xl font-medium text-white">Referral</h6>
                                <div className="gap-4 mt-4 sm:flex sm:mt-0">
                                    <div className="relative">
                                        <input
                                            type="text"
                                            onChange={this.handleSearchUser}
                                            value={this.state.searchValue}
                                            className="block w-full rounded bg-collaboratortable py-1.5 pl-4 pr-10 text-white placeholder:text-secondary sm:text-base"
                                            placeholder="Search Name"
                                            autoComplete="off"
                                            maxLength={50}
                                        />
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="absolute transform -translate-y-1/2 pointer-events-none right-3 top-1/2"
                                        >
                                            <path
                                                d="M7.66665 13.9997C11.1644 13.9997 14 11.1641 14 7.66634C14 4.16854 11.1644 1.33301 7.66665 1.33301C4.16884 1.33301 1.33331 4.16854 1.33331 7.66634C1.33331 11.1641 4.16884 13.9997 7.66665 13.9997Z"
                                                stroke="#10DACE"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M14.6666 14.6663L13.3333 13.333"
                                                stroke="#10DACE"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                    <button
                                        className="bg-UIprimary p-3 py-1.5 text-base rounded-lg text-white font-semibold whitespace-nowrap sm:mt-0 mt-4"
                                        onClick={() => {
                                            this.openCancelModal();
                                            this.getSubjects(
                                                this.state.searchValue,
                                                this.state.currentPage,
                                                this.state.todosPerPage
                                            );
                                        }}
                                    >
                                        Create
                                    </button>
                                </div>
                            </div>
                            <div className="flex flex-col gap-4 px-4 pt-6 sm:px-8">
                                <div
                                    className="rounded-lg bg-card"
                                    style={{ borderColor: 'rgba(255, 255, 255, 0.2)' }}
                                >
                                    <div
                                        className="px-4 border-b"
                                        style={{ borderColor: 'rgba(255, 255, 255, 0.2)' }}
                                    >
                                        <nav className="flex flex-col gap-4 sm:flex-row">
                                            <button
                                                className={
                                                    this.state.isTabName === 'create'
                                                        ? 'text-UIprimary font-medium text-lg py-4 px-3 block hover:text-UIprimary focus:outline-none border-b-2 '
                                                        : 'text-UIsecondary text-lg font-normal py-4 px-3 block focus:outline-none'
                                                }
                                                onClick={() => this.tabChange('create')}
                                            >
                                                Created
                                            </button>
                                            <button
                                                className={
                                                    this.state.isTabName === 'referral'
                                                        ? 'text-UIprimary font-medium text-lg py-4 px-3 block hover:text-emerald focus:outline-none border-b-2 '
                                                        : 'text-UIsecondary text-lg font-normal py-4 px-3 block focus:outline-none'
                                                }
                                                onClick={() => this.tabChange('referral')}
                                            >
                                                Received
                                            </button>
                                            <button
                                                className={
                                                    this.state.isTabName === 'completed'
                                                        ? 'text-UIprimary font-medium text-lg py-4 px-3 block hover:text-emerald focus:outline-none border-b-2 '
                                                        : 'text-UIsecondary text-lg font-normal py-4 px-3 block focus:outline-none'
                                                }
                                                onClick={() =>
                                                    this.tabChange('completed', () =>
                                                        this.getCompletedReferralList(
                                                            this.state.searchValue,
                                                            this.state.visitType,
                                                            0,
                                                            this.state.todosPerPage
                                                        )
                                                    )
                                                }
                                            >
                                                Completed
                                            </button>
                                        </nav>
                                    </div>
                                    {(this.state.isTabName === 'create' ||
                                        this.state.isTabName === 'referral') &&
                                    this.state.createReferralList.length === 0 ? (
                                        <div className="mt-10 mb-10 text-center text-white">
                                            {this.state.isLoading ? (
                                                <Loader />
                                            ) : this.state.isTabName === 'create' ? (
                                                RESPONSE_CONSTANT.CREATED_REFERRAL_UNAVAILABLE
                                            ) : (
                                                RESPONSE_CONSTANT.RECEIVED_REFERRAL_UNAVAILABLE
                                            )}
                                        </div>
                                    ) : (
                                        <div id="myTabContent">
                                            {this.state.isTabName === 'create' ? (
                                                <div
                                                    className="pt-4 overflow-x-auto rounded-lg bg-collaboratortable"
                                                    id="profile"
                                                    role="tabpanel"
                                                    aria-labelledby="profile-tab"
                                                >
                                                    {this.state.isLoading ? (
                                                        <div className="mt-10 mb-10">
                                                            <Loader />
                                                        </div>
                                                    ) : (
                                                        <div className="table-responsive table-scroll bg-collaboratortable">
                                                            <table className="table w-full">
                                                                <>
                                                                    <thead
                                                                        className="text-left text-UIsecondary whitespace-nowrap"
                                                                        style={{
                                                                            borderBottom:
                                                                                '1px solid rgba(255, 255, 255, 0.2)',
                                                                        }}
                                                                    >
                                                                        <tr>
                                                                            <>
                                                                                <th
                                                                                    scope="col"
                                                                                    className="p-3 font-medium"
                                                                                >
                                                                                    Team Member Name
                                                                                </th>
                                                                                {/* <th
                                                                                    scope="col"
                                                                                    className="p-3 font-medium"
                                                                                >
                                                                                    Student Number
                                                                                </th> */}
                                                                                <th
                                                                                    scope="col"
                                                                                    className="p-3 font-medium"
                                                                                >
                                                                                    Referral Date
                                                                                </th>
                                                                                <th
                                                                                    scope="col"
                                                                                    className="p-3 font-medium"
                                                                                >
                                                                                    Referred To
                                                                                </th>
                                                                                <th
                                                                                    scope="col"
                                                                                    className="p-3 font-medium"
                                                                                >
                                                                                    Referral Type
                                                                                </th>
                                                                                <th
                                                                                    scope="col"
                                                                                    className="p-3 font-medium"
                                                                                >
                                                                                    Notes
                                                                                </th>
                                                                            </>
                                                                        </tr>
                                                                    </thead>
                                                                    {this.state
                                                                        .createReferralList &&
                                                                        this.state
                                                                            .createReferralList
                                                                            .length !== 0 &&
                                                                        this.state.createReferralList.map(
                                                                            (data, index) => (
                                                                                <tbody
                                                                                    className="text-white break-word"
                                                                                    key={index}
                                                                                >
                                                                                    <tr
                                                                                        key={index}
                                                                                        className="whitespace-nowrap"
                                                                                        style={{
                                                                                            borderBottom:
                                                                                                '1px solid rgba(255, 255, 255, 0.2)',
                                                                                        }}
                                                                                    >
                                                                                        <td
                                                                                            className="p-3 table-ellipse"
                                                                                            title={
                                                                                                data.studentName
                                                                                            }
                                                                                        >
                                                                                            {data.studentName ??
                                                                                                ''}
                                                                                        </td>
                                                                                        {/* <td
                                                                                            className="p-3 table-ellipse"
                                                                                            title={
                                                                                                data.studentRollNumber
                                                                                            }
                                                                                        >
                                                                                            {
                                                                                                data.studentRollNumber
                                                                                            }
                                                                                        </td> */}
                                                                                        <td className="p-3 table-ellipse">
                                                                                            {moment(
                                                                                                data.createdAt
                                                                                            ).format(
                                                                                                'MMM DD, YYYY'
                                                                                            )}
                                                                                        </td>
                                                                                        <td
                                                                                            className="p-3 table-ellipse"
                                                                                            title={
                                                                                                data.educatorName
                                                                                            }
                                                                                        >
                                                                                            {
                                                                                                data.educatorName
                                                                                            }
                                                                                        </td>
                                                                                        <td
                                                                                            className="p-3"
                                                                                            style={{
                                                                                                color: data.sessionReferral
                                                                                                    ? '#8EFFF8'
                                                                                                    : '#8EFFF8',
                                                                                            }}
                                                                                        >
                                                                                            {data.sessionReferral
                                                                                                ? 'Session Referral'
                                                                                                : 'Element Referral'}
                                                                                        </td>
                                                                                        <td
                                                                                            className="p-3"
                                                                                            style={{
                                                                                                whiteSpace:
                                                                                                    'normal',
                                                                                            }}
                                                                                        >
                                                                                            {
                                                                                                data.notes
                                                                                            }
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            )
                                                                        )}
                                                                </>
                                                            </table>
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                this.state.isTabName === 'referral' && (
                                                    <div
                                                        className="pt-4 overflow-x-auto rounded-lg bg-collaboratortable"
                                                        id="dashboard"
                                                        role="tabpanel"
                                                        aria-labelledby="dashboard-tab"
                                                    >
                                                        {this.state.isLoading ? (
                                                            <div className="mt-10 mb-10">
                                                                <Loader />
                                                            </div>
                                                        ) : (
                                                            <div className="table-responsive table-scroll bg-collaboratortable">
                                                                <table className="table w-full">
                                                                    <>
                                                                        <thead
                                                                            className="text-left text-UIsecondary whitespace-nowrap"
                                                                            style={{
                                                                                borderBottom:
                                                                                    '1px solid rgba(255, 255, 255, 0.2)',
                                                                            }}
                                                                        >
                                                                            <tr>
                                                                                <>
                                                                                    <th
                                                                                        scope="col"
                                                                                        className="p-3 font-medium"
                                                                                    >
                                                                                        Team Member
                                                                                        Name
                                                                                    </th>
                                                                                    {/* <th
                                                                                        scope="col"
                                                                                        className="p-3 font-medium"
                                                                                    >
                                                                                        Student
                                                                                        Number
                                                                                    </th> */}
                                                                                    <th
                                                                                        scope="col"
                                                                                        className="p-3 font-medium"
                                                                                    >
                                                                                        Referral
                                                                                        Date
                                                                                    </th>
                                                                                    <th
                                                                                        scope="col"
                                                                                        className="p-3 font-medium"
                                                                                    >
                                                                                        Referred By
                                                                                    </th>
                                                                                    <th
                                                                                        scope="col"
                                                                                        className="p-3 font-medium"
                                                                                    >
                                                                                        Referral
                                                                                        Type
                                                                                    </th>
                                                                                    <th
                                                                                        scope="col"
                                                                                        className="p-3 font-medium"
                                                                                    >
                                                                                        Notes
                                                                                    </th>
                                                                                </>
                                                                            </tr>
                                                                        </thead>
                                                                        {this.state
                                                                            .createReferralList &&
                                                                            this.state
                                                                                .createReferralList
                                                                                .length !== 0 &&
                                                                            this.state.createReferralList.map(
                                                                                (data, index) => (
                                                                                    <tbody
                                                                                        className="text-white break-word"
                                                                                        key={index}
                                                                                    >
                                                                                        <tr
                                                                                            key={
                                                                                                index
                                                                                            }
                                                                                            className="whitespace-nowrap"
                                                                                            style={{
                                                                                                borderBottom:
                                                                                                    '1px solid rgba(255, 255, 255, 0.2)',
                                                                                            }}
                                                                                        >
                                                                                            <td
                                                                                                className="p-3 table-ellipse"
                                                                                                title={
                                                                                                    data.studentName
                                                                                                }
                                                                                            >
                                                                                                {data.studentName ??
                                                                                                    ''}
                                                                                            </td>
                                                                                            {/* <td
                                                                                                className="p-3 table-ellipse"
                                                                                                title={
                                                                                                    data.studentRollNumber
                                                                                                }
                                                                                            >
                                                                                                {
                                                                                                    data.studentRollNumber
                                                                                                }
                                                                                            </td> */}
                                                                                            <td className="p-3 table-ellipse">
                                                                                                {moment(
                                                                                                    data.createdAt
                                                                                                ).format(
                                                                                                    'MMM DD, YYYY'
                                                                                                )}
                                                                                            </td>
                                                                                            <td
                                                                                                className="p-3 table-ellipse"
                                                                                                title={
                                                                                                    data.referredByEducatorName
                                                                                                }
                                                                                            >
                                                                                                {
                                                                                                    data.referredByEducatorName
                                                                                                }
                                                                                            </td>
                                                                                            <td
                                                                                                className="p-3"
                                                                                                style={{
                                                                                                    color: data.sessionReferral
                                                                                                        ? '#8EFFF8'
                                                                                                        : '#8EFFF8',
                                                                                                }}
                                                                                            >
                                                                                                {data.sessionReferral
                                                                                                    ? 'Session Referral'
                                                                                                    : 'Element Referral'}
                                                                                            </td>
                                                                                            <td
                                                                                                className="p-3"
                                                                                                style={{
                                                                                                    whiteSpace:
                                                                                                        'normal',
                                                                                                }}
                                                                                            >
                                                                                                {
                                                                                                    data.notes
                                                                                                }
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                )
                                                                            )}
                                                                    </>
                                                                </table>
                                                            </div>
                                                        )}
                                                    </div>
                                                )
                                            )}
                                        </div>
                                    )}
                                    {this.state.isTabName === 'completed' &&
                                    this.state.completedReferralList.length === 0 ? (
                                        <div className="mt-10 mb-10 text-center text-white">
                                            {this.state.isLoading ? (
                                                <Loader />
                                            ) : (
                                                RESPONSE_CONSTANT.COMPLETED_REFERRAL_UNAVAILABLE
                                            )}
                                        </div>
                                    ) : (
                                        <div id="myTabContent">
                                            {this.state.isTabName === 'completed' && (
                                                <div
                                                    className="pt-4 overflow-x-auto rounded-lg bg-collaboratortable"
                                                    id="profile"
                                                    role="tabpanel"
                                                    aria-labelledby="profile-tab"
                                                >
                                                    {this.state.isLoading ? (
                                                        <div className="mt-10 mb-10">
                                                            <Loader />
                                                        </div>
                                                    ) : (
                                                        <div className="table-responsive table-scroll bg-collaboratortable">
                                                            <table className="table w-full">
                                                                <>
                                                                    <thead
                                                                        className="text-left text-UIsecondary whitespace-nowrap"
                                                                        style={{
                                                                            borderBottom:
                                                                                '1px solid rgba(255, 255, 255, 0.2)',
                                                                        }}
                                                                    >
                                                                        <tr>
                                                                            <>
                                                                                <th
                                                                                    scope="col"
                                                                                    className="p-3 font-medium"
                                                                                >
                                                                                    Team Member Name
                                                                                </th>
                                                                                {/* <th
                                                                                    scope="col"
                                                                                    className="p-3 font-medium"
                                                                                >
                                                                                    Student Number
                                                                                </th> */}
                                                                                <th
                                                                                    scope="col"
                                                                                    className="p-3 font-medium"
                                                                                >
                                                                                    Referral Date
                                                                                </th>
                                                                                <th
                                                                                    scope="col"
                                                                                    className="p-3 font-medium"
                                                                                >
                                                                                    Referred By
                                                                                </th>
                                                                                <th
                                                                                    scope="col"
                                                                                    className="p-3 font-medium"
                                                                                >
                                                                                    Referral Type
                                                                                </th>
                                                                                <th
                                                                                    scope="col"
                                                                                    className="p-3 font-medium"
                                                                                >
                                                                                    Notes
                                                                                </th>
                                                                            </>
                                                                        </tr>
                                                                    </thead>
                                                                    {this.state
                                                                        .completedReferralList &&
                                                                        this.state
                                                                            .completedReferralList
                                                                            .length !== 0 &&
                                                                        this.state.completedReferralList.map(
                                                                            (data, index) => (
                                                                                <tbody
                                                                                    className="text-white break-word"
                                                                                    key={index}
                                                                                >
                                                                                    <tr
                                                                                        key={index}
                                                                                        className="whitespace-nowrap"
                                                                                        style={{
                                                                                            borderBottom:
                                                                                                '1px solid rgba(255, 255, 255, 0.2)',
                                                                                        }}
                                                                                    >
                                                                                        <td
                                                                                            className="p-3 table-ellipse"
                                                                                            title={
                                                                                                data.studentName
                                                                                            }
                                                                                        >
                                                                                            {data.studentName ??
                                                                                                ''}
                                                                                        </td>
                                                                                        {/* <td
                                                                                            className="p-3 table-ellipse"
                                                                                            title={
                                                                                                data.studentRollNumber
                                                                                            }
                                                                                        >
                                                                                            {
                                                                                                data.studentRollNumber
                                                                                            }
                                                                                        </td> */}
                                                                                        <td className="p-3 table-ellipse">
                                                                                            {moment(
                                                                                                data.createdAt
                                                                                            ).format(
                                                                                                'MMM DD, YYYY'
                                                                                            )}
                                                                                        </td>
                                                                                        <td
                                                                                            className="p-3 table-ellipse"
                                                                                            title={
                                                                                                data.referredByEducatorName
                                                                                            }
                                                                                        >
                                                                                            {
                                                                                                data.referredByEducatorName
                                                                                            }
                                                                                        </td>
                                                                                        <td
                                                                                            className="p-3"
                                                                                            style={{
                                                                                                color: data.sessionReferral
                                                                                                    ? '#8EFFF8'
                                                                                                    : '#8EFFF8',
                                                                                            }}
                                                                                        >
                                                                                            {data.sessionReferral
                                                                                                ? 'Session Referral'
                                                                                                : 'Element Referral'}
                                                                                        </td>
                                                                                        <td
                                                                                            className="p-3"
                                                                                            style={{
                                                                                                whiteSpace:
                                                                                                    'normal',
                                                                                            }}
                                                                                        >
                                                                                            {
                                                                                                data.notes
                                                                                            }
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            )
                                                                        )}
                                                                </>
                                                            </table>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div className="flex items-center justify-end gap-2 mt-8 -space-x-px">
                                    {!this.state.isLoading && (
                                        <>
                                            {pageDisplayCount > 1 && (
                                                <Pagination
                                                    currentPage={this.state.currentPage}
                                                    pageDisplayCount={pageDisplayCount}
                                                    onPageChange={this.handlePageChange}
                                                />
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                            <SubjectReferralModal
                                openModal={this.state.cancelAppoimentIsOpen}
                                closeModal={() => {
                                    this.setState({ cancelAppoimentIsOpen: false });
                                }}
                                onChange={(event) => {
                                    this.setState({
                                        referralNotes: event.target.value,
                                    });
                                }}
                                submitCancelation={this.submitSubjectReferralNotes}
                                btnLoading={this.state.btnLoading}
                                dropdownSubjectList={this.state.dropdownSubjectList}
                                setIsTabName={(type) => {
                                    this.tabChange(type);
                                }}
                            />
                        </div>
                    </main>
                </div>
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showNotification: (message, type) => {
            dispatch(showNotification(message, type));
        },
        getSessionSubjectList: (values, callback) => {
            dispatch(getSessionSubjectList(values, callback));
        },
        submitSubjectReferralNotes: (values, callback) => {
            dispatch(submitSubjectReferralNotes(values, callback));
        },
        getCreatedReferralList: (values, callback) => {
            dispatch(getCreatedReferralList(values, callback));
        },
        getCompletedReferralList: (values, callback) => {
            dispatch(getCompletedReferralList(values, callback));
        },
    };
};

export default connect(null, mapDispatchToProps)(ReferralEducator);
